import Vue from 'vue';
import colorcircle from "../components/colorcircle.vue";

function initColorWorld() {
    if (document.getElementById('colorworld')) {
        new Vue({
            name: 'ColorWorld',
            el: '#colorworld',
            components: {
                colorcircle
            },
            data: {
            },
            methods: {
            },
            mounted() {
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", initColorWorld);
window.addEventListener("Pageeditor:insert", initColorWorld);
window.addEventListener("Pageeditor:change", initColorWorld);
